import { combineReducers } from 'redux';
import paginationReducer from './pagination.reducer';
import sharesReducer from './shares.reducer';

export default combineReducers({
  shares: sharesReducer,
  pagination: paginationReducer,
});
